import { jsx as d } from "react/jsx-runtime";
import { forwardRef as m } from "react";
import { P as f } from "./Pill-uAcQLotY.js";
const p = {
  auto: "success",
  review: "purple"
}, u = m(function({ mode: o, variant: e = "soft", size: r = "sm", uppercase: t = !0, children: s, ...a }, i) {
  return /* @__PURE__ */ d(
    f,
    {
      ref: i,
      tone: p[o],
      variant: e,
      size: r,
      uppercase: t,
      "data-mode": o,
      role: "status",
      ...a,
      children: s
    }
  );
});
u.displayName = "AiModeBadge";
export {
  u as A
};
//# sourceMappingURL=AiModeBadge-DXU_Al41.js.map
